<script>
	export let data;

	import { slide } from "svelte/transition";
	import { isMobile, isNewDataChanged } from "../../../../stores/variables";

	import { cloneDeep } from "lodash-es";

	if (data) {
		if (!data.newData) data.newData = [];
	}

	if (data.newData) {
		data[data.field_name] = data.newData[data.field_name];
		data.newData = [];
		data.newData[data.field_name] =
			data[data.field_name]["ranks"].split(",");
		data.list = cloneDeep(data[data.field_name]["list"]);
		data.newData[data.field_name].forEach((rank, i) => {
			delete data.list[rank];
			if (!rank) delete data.newData[data.field_name][i];
		});
		if (
			!data.newData[data.field_name][0] &&
			data.newData[data.field_name].length < 2
		) {
			data.newData[data.field_name] = [];
		}
		data.list = Object.values(data.list);
	}

	function close() {
		data.opened = !data.opened;
		let container = this;
		function temp(e) {
			if (!container.contains(e.target)) {
				data.opened = false;
				document.body.removeEventListener("click", temp);
			}
		}
		document.body.addEventListener("click", temp);
	}

	function handleDelete(item, i) {
		$isNewDataChanged = true;
		data.newData[data.field_name].splice(i, 1);
		data.list.push(data[data.field_name]["list"][item]);
		data = data;
	}
	function handleAdd(item, i) {
		$isNewDataChanged = true;
		data.list.splice(i, 1);
		let keys = Object.keys(data[data.field_name]["list"]);
		let values = Object.values(data[data.field_name]["list"]);
		values.forEach((value, j) => {
			if (value == item) {
				data.newData[data.field_name].push(keys[j]);
			}
		});
		data = data;
	}
</script>

{#if data.name}
	<h3>{data.name}</h3>
{/if}

{#if data}
	<div class="select">
		<div class="select__header" class:active={data.opened}>
			<div class="select__header-bg" on:click={close} />
			<span
				class={data.newData[data.field_name].length > 0 ? "active" : ""}
				>{data.description}</span
			>
			<ul class="select__header-list">
				{#each data.newData[data.field_name] as item, i}
					<li
						class="select__header-list-item"
						on:click={() => handleDelete(item, i)}
					>
						<span>{data[data.field_name]["list"][item]}</span>
						<i class="fas fa-times" />
					</li>
				{/each}
			</ul>
		</div>
		{#if data.opened && data.list}
			<div class="select__list-wrap">
				<ul
					class="select__list scrollbar-white {$isMobile
						? 'mobile'
						: 'not_mobile'}"
					transition:slide
				>
					{#each data.list as item, i}
						<li
							class="select__list-item"
							on:click={() => handleAdd(item, i)}
						>
							{item}
						</li>
					{/each}
				</ul>
			</div>
		{/if}
	</div>
{/if}

<style lang="scss">
	.select {
		display: flex;
		flex-direction: column;
		max-width: var(--module-width-1);
		position: relative;
		margin-top: 4px;

		&__header {
			display: flex;
			align-items: center;
			outline: 0;
			border: 1px solid var(--border-gray-1);
			color: var(--bg-black-1);
			min-height: 52px;
			font-size: 16px;
			line-height: 24px;
			padding: 9px 16px 4px;
			border-radius: 8px;
			transition: border-color 0.2s ease;

			&::before {
				content: "";
				position: absolute;
				align-self: center;
				display: flex;
				margin-left: auto;
				width: 10px;
				height: 10px;
				border: solid 3px var(--color-1);
				border-top: 0;
				border-right: 0;
				order: 100;
				transform: rotate(-45deg);
				transition: all 0.1s ease;
				right: 23px;
				top: calc(50% - 9px);
			}

			&:hover {
				border-color: var(--color-1);
			}
			&.active {
				border-color: var(--color-1);

				&::before {
					transform: rotate(135deg);
					margin-top: 5px;
				}
			}

			&-bg {
				position: absolute;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				cursor: pointer;
			}

			&-list {
				display: flex;
				flex-wrap: wrap;
				padding-right: 28px;

				&-item {
					display: flex;
					padding: 3px 5px;
					margin: 0 5px 5px 0;
					color: var(--text-black-1);
					border: solid 1px var(--border-gray-1);
					border-radius: 3px;
					align-items: center;
					cursor: pointer;
					z-index: 1;

					&:hover {
						background-color: var(--border-gray-2);
						> i {
							color: var(--color-1);
						}
					}

					> i {
						opacity: 0.5;
						margin-left: auto;
						padding-left: 6px;
						font-weight: 100;
						pointer-events: none;
						user-select: none;
					}
					> span {
						pointer-events: none;
						user-select: none;
					}
				}
			}

			> span {
				color: var(--text-gray-1);
				position: absolute;
				pointer-events: none;
				font-size: 16px;
				left: 16px;
				top: calc(50% - 9px);
				background: transparent;
				transition: all 0.2s ease;

				&.active {
					background: var(--bg-main-1);
					color: var(--color-1);
					font-size: 12px;
					top: -7px;
					line-height: 16px;
					border-radius: 3px;
					padding: 0 3px;
				}
			}
		}

		&__list {
			display: flex;
			flex-direction: column;
			padding: 4px 0;

			&-wrap {
				border-radius: 8px;
				margin-top: 2px;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				position: absolute;
				z-index: 1000;
				top: 100%;
				width: 100%;
				max-height: 150px;
				background: var(--bg-main-1);
				border: solid 1px var(--color-1);
			}

			&-item {
				cursor: pointer;
				display: flex;
				padding: 5px 16px;

				&:hover {
					background-color: var(--border-gray-2);
				}
			}
		}
	}
</style>
